'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse from "./presto.types$-Configure2-F-A-Freemium-Response.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Configure2FAFreemiumResponse$() {
}
export { $c_Lpresto_types$Configure2FAFreemiumResponse$ as $c_Lpresto_types$Configure2FAFreemiumResponse$ };
$p = $c_Lpresto_types$Configure2FAFreemiumResponse$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Configure2FAFreemiumResponse$;
/** @constructor */
function $h_Lpresto_types$Configure2FAFreemiumResponse$() {
}
export { $h_Lpresto_types$Configure2FAFreemiumResponse$ as $h_Lpresto_types$Configure2FAFreemiumResponse$ };
$h_Lpresto_types$Configure2FAFreemiumResponse$.prototype = $p;
$p.l = (function() {
  return "Configure2FAFreemiumResponse";
});
$p.cHj = (function(x$0) {
  return new $j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse.$c_Lpresto_types$Configure2FAFreemiumResponse(x$0.j(0));
});
var $d_Lpresto_types$Configure2FAFreemiumResponse$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Configure2FAFreemiumResponse$, "presto.types$Configure2FAFreemiumResponse$", ({
  YU: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Configure2FAFreemiumResponse$ as $d_Lpresto_types$Configure2FAFreemiumResponse$ };
var $n_Lpresto_types$Configure2FAFreemiumResponse$;
function $m_Lpresto_types$Configure2FAFreemiumResponse$() {
  if ((!$n_Lpresto_types$Configure2FAFreemiumResponse$)) {
    $n_Lpresto_types$Configure2FAFreemiumResponse$ = new $c_Lpresto_types$Configure2FAFreemiumResponse$();
  }
  return $n_Lpresto_types$Configure2FAFreemiumResponse$;
}
export { $m_Lpresto_types$Configure2FAFreemiumResponse$ as $m_Lpresto_types$Configure2FAFreemiumResponse$ };
//# sourceMappingURL=presto.types$-Configure2-F-A-Freemium-Response$.js.map
